// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"styles_footerContainer__3IcoO","logo":"styles_logo__3WpTm"};